
import React, { useMemo } from "react";
import { Button } from "react-bootstrap";
import { iconDocuments } from '@common/_assets/images';
import { useNavigate } from "react-router";

export type useDocumentsCheckReturn = {
    documentCheckButton: JSX.Element;
}

interface IDocumentsCheck {
    route: string;
}

export const useDocumentsCheck = ({ route }: IDocumentsCheck): useDocumentsCheckReturn => {

    const navigate = useNavigate();

    const documentCheckButton = useMemo(() => {
        return (
            <Button className="documents-check"
                onClick={() => {
                    navigate(route);
                }}>
                <img src={iconDocuments}
                    alt={"PC"} /></Button>
        )
    }, [route, navigate]);

    return useMemo(() => {
        return {
            documentCheckButton,
        }
    }, [documentCheckButton])
};
